/* A card in the tunnel */
import kontra from 'kontra';

import card from '../../assets/card.png';
import hover from '../../assets/hover.png';
import cardFaceUp from '../../assets/card-faceup.png';
import enemyCard from '../../assets/enemyCard.png';
import shield from '../../assets/shield.png';
import spanner from '../../assets/spanner.png';
import health from '../../assets/health.png';
import fiveHundred from '../../assets/500.png';
import fourOhFour from '../../assets/404.png';
import twoHundred from '../../assets/200.png';
import spider from '../../assets/spider.png';
import robot from '../../assets/robot.png';
import worm from '../../assets/worm.png';

const { Sprite, imageAssets, pointerOver, emit, on } = kontra;

const CardState = {
  IN_PLAY: 0,
  LEAVING: 1,
  PROMOTING: 2,
  EFFECTING: 3,
  EFFECTED: 4
};

export const CardType = {
  SHIELD: 0,
  SPANNER: 1,
  HEALTH: 2,
  OK: 3,
  SERVER_ERROR: 4,
  NOT_FOUND: 5,
  SPIDER: 6,
  ROBOT: 7,
  WORM: 8
};

const allTypes = [
  CardType.SHIELD,
  CardType.SHIELD,
  CardType.SPANNER,
  CardType.HEALTH,
  CardType.OK,
  // bad cards 2x as likely as good cards
  CardType.NOT_FOUND,
  CardType.NOT_FOUND,
  CardType.SERVER_ERROR,
  CardType.SPIDER,
  CardType.SPIDER,
  CardType.ROBOT,
  CardType.ROBOT,
  CardType.WORM
];

const typeToImage = (cardType) => {
  switch (cardType) {
    case CardType.SHIELD: return imageAssets[shield];
    case CardType.SPANNER: return imageAssets[spanner];
    case CardType.HEALTH: return imageAssets[health];
    case CardType.OK: return imageAssets[twoHundred];
    case CardType.SERVER_ERROR: return imageAssets[fiveHundred];
    case CardType.NOT_FOUND: return imageAssets[fourOhFour];
    case CardType.SPIDER: return imageAssets[spider];
    case CardType.ROBOT: return imageAssets[robot];
    case CardType.WORM: return imageAssets[worm];
  }
};

export class Card extends Sprite.class {
  constructor (properties) {
    const { row, column, name, ...otherProps } = properties;
    super(otherProps);

    this.state = CardState.IN_PLAY;
    this.row = row;
    this.column = column;

    this.name = name;
    this.width = 160;
    this.height = 192;
    this.hovered = false;

    this.cardType = allTypes[Math.floor(Math.random() * allTypes.length)];

    this.faceDown = imageAssets[card];
    this.faceUp = imageAssets[cardFaceUp];

    if (
      this.cardType === CardType.SPIDER ||
        this.cardType === CardType.ROBOT ||
        this.cardType === CardType.WORM
    ) {
      this.faceUp = imageAssets[enemyCard];
    }

    this.hoverImage = imageAssets[hover];

    this.alpha = 1.0;
    this.promoteFrames = 30;

    on('cursor-move', (value) => this.cursor = value);
  }

  withinRange () {
    return Math.abs(this.cursor - this.column) < 2;
  }

  update () {
    this.hovered = pointerOver(this) && this.row === 0 && this.withinRange();

    this.advance();

    switch (this.state) {
      case CardState.LEAVING: {
        this.alpha = Math.max(this.alpha - 0.05, 0);
        break;
      }
      case CardState.PROMOTING: {
        this.promoteFrames -= 1;
        if (this.promoteFrames <= 0) {
          this.state = CardState.IN_PLAY;
          this.dy = 0;
          this.y = 60 + this.row * 216;
        }
        break;
      }
      case CardState.EFFECTING: {
        this.effectFrames -= 1;
        if (this.effectFrames === 0) {
          this.effect();
          this.state = CardState.EFFECTED;
        }
        break;
      }
      default:
        break;
    }
  }

  leave () {
    this.state = CardState.LEAVING;
    this.dy = -10;
  }

  stay () {
    this.state = CardState.EFFECTING;
    this.dy = 0;
    this.effectFrames = 20;
  }

  effect () {
    emit('card-effect', this.cardType);
  }

  promote () {
    this.state = CardState.PROMOTING;
    this.row -= 1;
    this.dy -= 10;
    this.promoteFrames = 20;
  }

  onDown () {
    if (this.row === 0 && this.state === CardState.IN_PLAY && this.withinRange()) {
      emit('card-click', { row: this.row, column: this.column });
    }
  }

  render () {
    this.context.save();
    this.context.globalAlpha = this.alpha;
    if (!this.withinRange()) {
      this.context.globalAlpha = 0.3;
    }
    if (this.row < 2) {
      this.context.drawImage(this.faceUp, this.x, this.y);
      this.context.drawImage(typeToImage(this.cardType), this.x + 16, this.y + 32);
    } else {
      this.context.drawImage(this.faceDown, this.x, this.y);
    }
    // if (!this.withinRange()) {
    //   this.context.save();
    //   this.context.fillStyle = 'rgba(33, 33, 33, 0.5)';
    //   this.context.fillRect(this.x, this.y, 160, 192);
    //   this.context.restore();
    // }
    this.context.restore();

    if (this.hovered && this.dy === 0) {
      this.context.drawImage(this.hoverImage, this.x, this.y);
    }
  }
}
